import script from "./Iframe.vue?vue&type=script&setup=true&lang=js"
export * from "./Iframe.vue?vue&type=script&setup=true&lang=js"

import "./Iframe.vue?vue&type=style&index=0&id=1ea487c5&lang=css"

const __exports__ = script;

export default __exports__